var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"create",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('content-header')]},proxy:true}])},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('configs-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }